import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import { t } from '@lingui/core/macro'

export const InvalidFileName = () => {
  return (
    <Alert severity="error">
      <AlertTitle>{t`Invalid filename`}</AlertTitle>
      {t`Please rename the file to include only valid characters.`}
      <small> {t`(numbers, letters, hyphens, underscores)`}</small>
    </Alert>
  )
}
